import type { FaireThemeEntity } from "../../entity_types/theme";

export const mindful_and_vegan_indulgences: FaireThemeEntity = {
  token: "mindful-and-vegan-indulgences",
  type: "theme",
  name: "Mindful & Vegan Indulgences",
  description: "Clean-label sweets that align with your shop's holistic and artisanal values. Offer your patrons decadent, guilt-free treats that are vegan and gluten-free.",
  teaser: "Your profile highlights strong preferences for 'vegan', 'organic', and 'handmade' products, which complements your therapeutic bodywork and Vedic practice offerings.",
  detail: "This theme is directly supported by the Vegan Peanut Butter Doughnuts in the payload, which are gluten-free, dairy-free, and made with 'mad clean' ingredients.",
  bgColor: "#C4D4B0",
  tileBgColor: "#3a4c6b",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_nsqc4dmeqc",
    "p_8yruy60bvy",
    "p_nb2pp2ua76",
    "p_2h6d2fpjeq",
    "p_wzpjqbtqnd",
    "p_9s6qxhcgkt",
    "p_f1oaqk8npf",
    "p_kzznwb3tpr",
    "p_z9pxy3nn7g",
    "p_yrej9n93jz",
    "p_5a3vgqu69m",
    "p_325erbmv35",
    "p_56tp7i6lxy",
    "p_xyzhx6ty4s",
    "p_k99gmuweu9",
    "p_4couom35k1",
    "p_stmngbmv7b",
    "p_2me5bgd4jg",
    "p_k78s256van",
    "p_94d5iwtr3l",
    "p_estee38kn7",
    "p_m2dr4d3xa4",
    "p_kkfm8ryqyw",
    "p_c7d2cjbn5x",
    "p_myfrpzf6mp",
    "p_8hfcq593am",
    "p_bedq9qn58g",
    "p_f4vvkgezfn",
    "p_k9njh275f3",
    "p_bnjkzqmazs",
    "p_drhxxakxe9",
    "p_tsg26rabxb",
    "p_ztw92m8jn4",
    "p_qgpyfy39rv",
    "p_7ztnv97z3d",
    "p_jq3krbhymb",
    "p_dm4av5ug37",
    "p_knw8h7htnj",
    "p_rbzha5urmu",
    "p_nn8pnb85xq",
    "p_u7mswf2r75",
    "p_jwxwsdg2wp",
    "p_xsyw828equ",
    "p_que8rz3c2r",
    "p_6zgjbn7h2s",
    "p_c6xvmdgaz4",
    "p_5qx242qxfn",
    "p_f3z7cyupt9",
    "p_a6u477hh7c",
    "p_px56kpps3w",
    "p_b2chvcwprs",
    "p_fmp5yhy27y",
    "p_kuyzbp7eek",
    "p_n83442wbwf",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
